import { request } from 'root/common/request';
import config from './url';

/**
 * 页面入口图片接口
 */
export function pageImage(params) {
    return request({
        url: config.pageImage,
        method: 'GET',
        params,
        isNeedToken: false,
    });
}

/**
 * 用户提醒列表接口
 */
export function list(params) {
    return request({
        url: config.list,
        method: 'GET',
        params,
        isNeedToken: false,
    });
}

/**
 * 删除用户提醒接口
 */
export function deleteReminder(data) {
    return request({
        url: config.deleteReminder,
        method: 'POST',
        data,
        isNeedToken: false,
    });
}

/**
 * 编辑用户提醒接口
 */
export function editReminder(params) {
    return request({
        url: config.editReminder,
        method: 'GET',
        params,
        isNeedToken: false,
    });
}

/**
 * 创建用户提醒接口
 */
export function storeReminder(data) {
    return request({
        url: config.storeReminder,
        method: 'POST',
        data,
        isNeedToken: false,
    });
}

/**
 * 更新用户提醒接口
 */
export function saveReminder(data) {
    return request({
        url: config.saveReminder,
        method: 'POST',
        data,
        isNeedToken: false,
    });
}

/**
 * 获取日历提醒信息
 */
export function reminderInfo(params) {
    return request({
        url: config.reminderInfo,
        method: 'GET',
        params,
        isNeedToken: false,
    });
}
